import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Overlay from '../Widget/Overlay';
import OverlayPartner from '../Widget/OverlayPartner';
import OverlayPublisher from '../Widget/OverlayPublisher';
import WidgetHeader from '../Widget/WidgetHeader';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import { Container, RockTheVoteLabel } from '../DefaultStyles/Details';
import { isLongText } from '../../components/Shared/commonFunctions';
import { RockTheVoteDetails } from '../../components/Shared/rockTheVoteDetails';
import AnswerButton from '../../components/Assessment/AnswerButton';
import ShareDrawer from '../../components/ShareDrawer';
import {
    Body,
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer,
    RTVLogo,
    Title
} from '../DefaultStyles/Shared';

import {
    onBackWithinCard,
    setOverlayPartnerVisible,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';
import { onGoToForm } from './actions';

import { CardTypes } from '../../utils/enums';

class CheckRegistrationStart extends React.Component {
    componentDidMount() {
        this.forceUpdate();
    }
    render() {
        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner
                    transitionType="right-to-left"
                    logo={RTVLogo}
                    name={this.props.rockTheVoteTitle}
                    description={this.props.rockTheVoteDescription}
                />
                <Body>
                    <WidgetHeader />
                    <Content isContactAction={false} isSingleAction={true}>
                        <Title
                            isLongText={isLongText(this.props.title, 60)}
                            isExtraLongText={isLongText(this.props.title, 95)}
                            onClick={e =>
                                this.props.setOverlayPartnerVisible(true, e, false)
                            }
                            dangerouslySetInnerHTML={{
                                __html: this.props.title
                            }}
                        />
                        <DetailsContainer>
                            <Details>
                                <Description
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(
                                            true,
                                            e,
                                            false
                                        )
                                    }
                                    isLongText={isLongText(this.props.subTitle, 90)}
                                    isExtraLongText={isLongText(this.props.subTitle, 160)}
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.subTitle
                                    }}
                                />
                                <RockTheVoteLabel
                                    color={this.props.theme.colors.primary}
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(true, e, true)
                                    }
                                >
                                    {this.props.rockTheVoteLabel}
                                </RockTheVoteLabel>
                            </Details>
                        </DetailsContainer>
                    </Content>
                    <AutoScalingButtonSet mobileStyled={true} mobileLeftPosition={8}>
                        <AnswerButton
                            text={this.props.registerButtonText}
                            useLoadingSpinner={false}
                            onClick={() => {
                                this.props.setExitingCardProps(
                                    'checkRegistration',
                                    this.props,
                                    this.props.activeAction
                                );

                                this.props.onGoToForm(
                                    this.props.actionIdentifier,
                                    this.props.actionInitiated
                                );
                            }}
                        />
                    </AutoScalingButtonSet>
                    <Footer>
                        <ShareDrawer
                            beforeBack={() => {
                                this.props.setExitingCardProps(
                                    'checkRegistration',
                                    this.props,
                                    this.props.activeAction
                                );
                            }}
                            goBack={() => {
                                return this.props.card.type === CardTypes.actionChoice
                                    ? this.props.onBackWithinCard(
                                          this.props.actionIdentifier,
                                          this.props.card,
                                          false
                                      )
                                    : null;
                            }}
                            fullwidth={this.props.card.type === CardTypes.actionChoice}
                            rightAlign={this.props.card.type !== CardTypes.actionChoice}
                            hasBackButton={
                                this.props.card.type === CardTypes.actionChoice
                            }
                            backgroundColor={'#fff'}
                        />
                    </Footer>
                </Body>
            </Container>
        );
    }
}

CheckRegistrationStart.propTypes = {
    activeAction: PropTypes.object.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    card: PropTypes.object.isRequired,
    onGoToForm: PropTypes.func.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    registerButtonText: PropTypes.string.isRequired,
    rockTheVoteDescription: PropTypes.string,
    rockTheVoteLabel: PropTypes.string,
    rockTheVoteTitle: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    subTitle: PropTypes.string,
    title: PropTypes.string,
    theme: PropTypes.object
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'checkRegistration',
            ['/checkRegistration', '/checkRegistration/start)'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const defaultTitle = 'Check to see if you are registered to vote.';
        const defaultText = `Unsure of your registration status? Take a minute to verify that you are all set for this year's elections.`;
        const defaultButtonText = `VERIFY`;

        return {
            activeAction: state.widget.activeAction,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            title: state.widget.activeAction.title || defaultTitle,
            subTitle: state.widget.activeAction.text || defaultText,
            actionIdentifier: state.widget.activeAction.identifier,
            actionInitiated: state.checkRegistration.actionInitiated,
            rockTheVoteTitle: RockTheVoteDetails.title,
            rockTheVoteDescription: RockTheVoteDetails.description,
            rockTheVoteLabel: RockTheVoteDetails.label,
            registerButtonText:
                state.widget.activeAction.customButtonText || defaultButtonText,
            theme: state.widget.theme
        };
    },
    {
        onBackWithinCard,
        onGoToForm,
        setExitingCardProps,
        setOverlayPartnerVisible
    }
)(CheckRegistrationStart);
